import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import PendingIcon from '@mui/icons-material/Pending';
import WarningIcon from '@mui/icons-material/Warning';
import { Chip, ChipProps } from '@mui/material';

export type StatusChipStatus = 'success' | 'error' | 'warning' | 'info' | 'pending' | 'neutral';

interface StatusChipProps extends Omit<ChipProps, 'color' | 'icon'> {
  status: StatusChipStatus;
}

const statusConfig: Record<StatusChipStatus, Pick<ChipProps, 'color' | 'icon'>> = {
  success: { color: 'success', icon: <CheckCircleIcon /> },
  error: { color: 'error', icon: <ErrorIcon /> },
  warning: { color: 'warning', icon: <WarningIcon /> },
  info: { color: 'info', icon: <InfoIcon /> },
  pending: { color: 'default', icon: <PendingIcon /> },
  neutral: { color: 'default' },
};

const StatusChip = ({
  status,
  size = 'small',
  variant = 'outlined',
  ...props
}: StatusChipProps) => <Chip size={size} variant={variant} {...statusConfig[status]} {...props} />;

export default StatusChip;
